import { IExecutionOptions, IQueryOptions } from '../models/query';
import { IPropQueries } from '../models/common/IPropQueries';
import { Query } from '../query/Query';
import { deepMergeObjects } from '../utils/object';

export abstract class QueryStore {
	abstract get executionOptions(): IExecutionOptions;
	abstract initialize(): Promise<void>;
	abstract query(options?: IQueryOptions, overrideExecutionOptions?: Partial<IExecutionOptions>): any;
	mergeQueriesAndProps<T>(componentOrchestration?: IPropQueries<any, any>): T | undefined {
		if (componentOrchestration) {
			const { props, queries } = componentOrchestration;
			const queryResults = queries ? Query.convertQueryMime(queries, this.executionOptions) : {};
			const response: T = deepMergeObjects(props || {}, queryResults);
			return response;
		}
	}
}